module.exports = __webpack_public_path__ + "media/images/story_ranking_mailer/rank_no1-415d1048550324de209b0a52fe7ca4fd.png";